import React from 'react';

import {DialogTitle, DialogActions, DialogContent, Link, Typography} from '@mui/material';
import {IconAlertTriangle} from '@zoom/sun-ui-icon';
import {useTranslation} from 'react-i18next';

import {TypographyH3} from 'Components/Appointments/Style';
import {ZmQuaternaryBtn, ZmPrimaryBtn, ZmSecondaryBtn} from 'Components/ZmButtons';
import {ZmDialog} from 'Components/ZmDialogs';

/**
 * Redirect Dialog Component
 * @param {Object} props
 * @return {ReactElement}
 */
export default function RedirectDialog(props) {
  const {
    // clearTimeout,
    displayRedirectDialog,
    redirectUrl,
    setDisplayRedirectDialog} = props;

  const {t} = useTranslation();
  return (
    <ZmDialog
      open={displayRedirectDialog}
      sx={{
        'overflow': 'auto',
        '.MuiDialog-container': {
          'minWidth': '450px',
        },
      }}
      PaperProps={{
        sx: {
          minWidth: '440px',
        },
      }}
    >
      <DialogTitle>
        <TypographyH3>{t('booking.redirectingMsg')}</TypographyH3>
      </DialogTitle>
      <DialogContent sx={{padding: '8px 0'}}>
        <Typography>
          {t('booking.openInNewTab')}
        </Typography>
        <Link
          href={redirectUrl}
          style={{
            marginTop: '8px',
            maxWidth: '400px',
            display: 'inline-block',
            overflow: 'wrap',
            wordBreak: 'break-word',
          }}
        >{redirectUrl}</Link>
      </DialogContent>
      <DialogActions sx ={{flexDirection: 'row-reverse', justifyContent: 'space-between'}}>
        <div>
          <ZmQuaternaryBtn
            size="small"
            startIcon={<IconAlertTriangle />}
            onClick={() => {
              setDisplayRedirectDialog(false);
              // clearTimeout();
            }}
            sx={{
              marginRight: '10px',
            }}
          >
            <Link href="https://zoom.us/trust-form" underline="none"
              target="_blank" rel="noopener noreferrer"
            >
              {t('booking.reportPhishing')}
            </Link>
          </ZmQuaternaryBtn>
          <ZmPrimaryBtn
            size="small"
            // onClick={clearTimeout}
            sx={{
              marginRight: '10px',
            }}
          >
            <Link href={redirectUrl} underline="none"
              target="_blank" rel="noopener noreferrer"
              style={{color: 'inherit'}}
            >
              {t('booking.openLink')}
            </Link>
          </ZmPrimaryBtn>
          <ZmSecondaryBtn
            size="small"
            onClick={() => {
              setDisplayRedirectDialog(false);
              // clearTimeout();
            }}
            sx={{marginRight: '10px'}}
          >
            {t('common.cancel')}
          </ZmSecondaryBtn>
        </div>
      </DialogActions>
    </ZmDialog>
  );
}
